{
    "title": "Sign Up Validation",
    "subtitle": "Please enter the verification code sent to your email. Check your inbox and spam folder.",
    "placeholder": "Verification Code",
    "sendagain": "Resend Verification Code"
}